import { createContext, useContext } from 'react';
import { createLogger } from '../../utils/logger/createLogger';
export const LoggerContext = createContext(undefined);
const fallbackLogger = createLogger({
    context: {
        mfe: 'unknown',
        team: 'unknown',
    },
});
/**
 * Custom hook to get the logger instance.
 *
 * @throws An error if the hook is used outside of a LoggerContext.
 * @returns The logger instance
 */
export const useLogger = () => {
    const logger = useContext(LoggerContext);
    if (!logger) {
        return fallbackLogger;
    }
    return logger;
};
